import { useParams } from '@tanstack/react-router';
import { IAlarm } from '_/api/alarms/alarms.api';
import { useAlarms } from '_/hooks/useAlarms';
import React, { createContext, useContext, ReactNode } from 'react';

interface AlarmsContextValue {
  alarmGroupId: string | undefined;
  alarms: IAlarm[];
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

const AlarmsContext = createContext<AlarmsContextValue | undefined>(undefined);

export function AlarmsProvider({ children }: { children: ReactNode }) {
  const params = useParams({ strict: false }) as Partial<{ alarmGroupId?: string }>;
  const alarmGroupId = params.alarmGroupId || '';

  // Fetch alarms using React Query
  const { data: alarms, isLoading, isError, error } = useAlarms(alarmGroupId);

  const value: AlarmsContextValue = {
    alarmGroupId: alarmGroupId,
    alarms: alarms || [],
    isLoading: isLoading,
    isError: isError,
    error: error as Error | null,
  };

  return <AlarmsContext.Provider value={value}>{children}</AlarmsContext.Provider>;
}

export function useAlarmsContext() {
  const context = useContext(AlarmsContext);
  if (context === undefined) {
    throw new Error('useAlarmsContext must be used within an AlarmsProvider');
  }
  return context;
}
